import { useNavigate } from "react-router-dom";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { SxProps, Theme, useTheme } from "@mui/material/styles";

interface GoBackButtonProps {
  buttonStyles?: SxProps<Theme>;
  showLabel?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export const GoBackButton = ({
  buttonStyles = {},
  showLabel = true,
  disabled = false,
  onClick,
}: GoBackButtonProps) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Button
      type="button"
      variant="text"
      onClick={onClick ? onClick : () => navigate(-1)}
      disabled={disabled}
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        backgroundColor: "transparent",
        padding: 0,
        border: 0,
        "&:hover > .MuiSvgIcon-root": {
          backgroundColor: theme.palette.grey[100],
          transition: "background-color 0.2s",
        },
        "&:hover": {
          backgroundColor: "transparent",
        },
        ...buttonStyles,
      }}
      aria-label="Go back button">
      <ChevronLeftIcon
        sx={{
          color: disabled ? "action.disabled" : "#000",
          fontSize: 24,
          width: theme.spacing(5),
          height: theme.spacing(5),
          padding: theme.spacing(0.5),
          border: `1px solid ${theme.palette.grey[200]}`,
          borderRadius: "50%",
        }}
      />
      {showLabel && (
        <Typography
          ml={1.5}
          color={disabled ? "text.disabled" : "text.primary"}>
          Back
        </Typography>
      )}
    </Button>
  );
};

export default GoBackButton;
